import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Card, CardMedia, Typography } from '@mui/material'
import React from 'react'
import NoImage from 'src/Resources/Images/shop/NoImage.png'
import { makeStyles } from 'tss-react/mui'

type BasicSystemConfigurationCardProps = {
  image: string | undefined
  name: string | undefined
}

const useStyles = makeStyles()(theme => ({
  container: {
    margin: 0,
    padding: 0,
    objectFit: 'contain',
    width: '100%',
    height: 'auto',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  productImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    margin: 0,
    padding: 0,
  },
}))

const BasicSystemConfigurationCard: React.FC<BasicSystemConfigurationCardProps> = ({ image, name }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  return (
    <Box>
      {name ? (
        <>
          <Card className={classes.container}>
            <CardMedia className={classes.productImage} component="img" image={image ? image : NoImage} />
          </Card>
          <Typography mt={2} variant="h6">
            {name}
          </Typography>
        </>
      ) : (
        <Typography variant="h4">{t('shop.system-configure-card.not-selected-yet')}</Typography>
      )}
    </Box>
  )
}

export default BasicSystemConfigurationCard
